import React from "react";
import { Shell } from "./components/layout/Shell.tsx";

export const App: React.FC = () => {
  return <Shell />;
};

export default App;
